import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  readonly analyzeHost = environment.api;
  readonly videoHost = environment.apache;
  readonly MODEL_HANDS = 'hands';
  readonly MODEL_POSE = 'pose';
  readonly MODEL_FACE = 'face';
  /*readonly analyzeHost = 'http://localhost:5151/';
  readonly videoHost = 'http://localhost:5150/';*/

  model = this.MODEL_FACE;

  constructor(private http: HttpClient) {
  }

  public uploadMultiMedia(fd, onSuccess = null, onError = null): void {
    this.http.post(this.analyzeHost + this.model, fd)
      .subscribe((data: any) => {
        if (onSuccess) {
          onSuccess(this.videoHost + data.download, this.videoHost + data.csv);
        }
      }, err => {
        if (onError) {
          onError();
        }
      });
  }
}
